<template>
  <div>
    <v-data-table :key="updater" :headers="headers" :items="disciplineCoaches" sort-by="Id" class="elevation-1">
      <!-- Associate users in top datatable -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>

          <!-- Add users dialog -->
          <v-dialog v-model="dialog" fullscreen  v-if="canManageCurrentDiscipline">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" @click="openAssociateUserDialog">Associer entraîneurs</v-btn>
            </template>
            <!--Partie de saisie du dialog-->
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="usersToAssociate"
                      label="Utilisateurs à associer"
                      :items="usersNotInDiscipline"
                      item-text="email"
                      item-value="id"
                      attach
                      chips
                      multiple
                      return-object
                      clearable
                      style="min-width: 200px"
                    ></v-select>
                  </v-col>
                </v-container>
              </v-card-text>
              <!--Fin du dialog-->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog()">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="associateUserToDiscipline(usersToAssociate)">Associer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Actions on discipline -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon class="mr-2" @click="navigateToCoach(item)" title="Consulter le coach">mdi-open-in-app</v-icon>
        <v-icon @click="removeUserFromDiscipline(item.id)" v-if="canManageCurrentDiscipline">mdi-power-plug-off</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  affectCoachesToDisciplineAsync,
  removeCoachFromDisciplineAsync,
  getCoachesNotInDisciplineAsync,
  getDisciplineCoachesAsync,
  getIsManagerPartOfDisciplineAsync,
} from "../../api/disciplinesApi";
import store from "@/store";
import { VDataTable } from "vuetify/lib";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";
import { getIsUserPartOfFederationAsync } from "@/api/federationsApi";

export default {
  components: {
    VDataTable,
  },

  props: {
    disciplineId_prop: Number,
  },

  data: () => ({
    isCurrentUserPartOfFederation: false,
    isCurrentUserManagerOfDiscipline: false,
    authService: AuthService,
    federationId: null,
    disciplineId: null,
    dialog: false,
    headers: [
      // { text: "Id", value: "id", sortable: true },
      { text: "Email", value: "email", sortable: true },
      { text: "Prénom", value: "firstName", sortable: true },
      { text: "Nom", value: "lastName", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    usersToAssociate: [],
    disciplineCoaches: [],
    editedIndex: -1,
    editedItem: {},
    usersNotInDiscipline: [],
    updater: 0,
  }),

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    $route() {
      this.initPage();
    },
  },

  computed: {
    canViewCurrentDiscipline() {
      // Can view own discipline and is part of current discipline
      let canViewOwnDisciplineAndIsPartOfCurrentDiscipline = PermissionsService.DisciplinesPermissionsService.canViewOwnDiscipline && this.isCurrentUserManagerOfDiscipline;
      // Can view all Disciplines
      let canViewAllDisciplines = PermissionsService.DisciplinesPermissionsService.canViewAllDisciplinesOwnFederation;
      return canViewOwnDisciplineAndIsPartOfCurrentDiscipline || canViewAllDisciplines;
    },
    canManageCurrentDiscipline() {
      // Can manage own discipline and is part of current discipline
      let canManageCurrentDisciplineAndIsPartOfCurrentDiscipline =
        PermissionsService.DisciplinesPermissionsService.canManageOwnDiscipline && this.isCurrentUserManagerOfDiscipline;
      // Can manage all disciplines of the current federation
      let canManageAllDisciplines = PermissionsService.DisciplinesPermissionsService.canManageAllDisciplinesOwnFederation && this.isCurrentUserPartOfFederation;
      return canManageCurrentDisciplineAndIsPartOfCurrentDiscipline || canManageAllDisciplines;
    },
  },

  async mounted() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      // Override the props values from the url if provided
      this.federationId = this.$route.params.federationId ? parseInt(this.$route.params.federationId) : null;
      this.disciplineId = this.$route.params.disciplineId ? parseInt(this.$route.params.disciplineId) : this.disciplineId_prop;

      // Check if the current user is part of current federation
      this.isCurrentUserPartOfFederation = await getIsUserPartOfFederationAsync(this.authService.userId, this.federationId);      
      // Check if the current user is part of current discipline
      this.isCurrentUserManagerOfDiscipline = await getIsManagerPartOfDisciplineAsync(this.authService.userId, this.disciplineId);

      // Check if the user can see this page
      if (!this.canViewCurrentDiscipline) {
        store.dispatch("setSnackbar", {
          title: `Non Autorisé`,
          text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
          status: "warning",
          timeout: 2000,
        });

        this.$router.replace("/");
      }

      this.initializeList();
    },

    // Get the discipline's users and the list of users not in discipline
    async initializeList() {
      // get the list of all users in order to provide it to the list of available user to add in the discipline
      this.usersNotInDiscipline = await getCoachesNotInDisciplineAsync(this.disciplineId);

      // Build the datatable values from the prop
      this.disciplineCoaches = await getDisciplineCoachesAsync(this.disciplineId);
    },

    // navigate to the coach panel
    navigateToCoach(item) {
      this.$router.push({
        name: "CoachPanel",
        params: {
          federationId: this.federationId,
          disciplineId: this.disciplineId,
          coachId: item.id,
          tab: "teams",
        },
      });
    },

    // Associate a user to a discipline
    async associateUserToDiscipline() {
      var usersToAssociateIds = this.usersToAssociate.map((u) => u.id);

      var result = await affectCoachesToDisciplineAsync(this.disciplineId, usersToAssociateIds);

      if (result) {
        store.dispatch("setSnackbar", {
          title: "Utilisateur(s) associé(s)",
          text: "Les utilisateurs ont bien été associés à la discipline.",
          status: "success",
          timeout: 2000,
        });
      }

      this.closeDialog();

      await this.initializeList();
    },

    // Remove the association between the discipline and the user
    async removeUserFromDiscipline(userId) {
      if (confirm("Etes-vous sûr de vouloir retirer cet utilisateur de la discipline ?")) {
        var result = await removeCoachFromDisciplineAsync(this.disciplineId, userId);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Utilisateur retiré",
            text: "L'utilisateur a bien été retiré de la discipline.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Open the associate user dialog
    openAssociateUserDialog() {
      this.dialog = true;
    },

    // Close the associate user dialog
    closeDialog() {
      this.dialog = false;
      this.usersToAssociate = [];
    },
  },
};
</script>
